import styled from "styled-components";
import { Layout, Menu, Button } from "antd";
import { Link } from "react-router-dom";
import { Header } from "antd/lib/layout/layout";
// import Sider from "antd/es/layout/Sider";

const { Content, Sider } = Layout;

export const StyledContainer = styled(Content)`
  /* margin-right: 20px; */
  display: flex;
  margin-bottom: 20px;
  text-align: left;
  background: white;

  :where(.css-dev-only-do-not-override-3mqfnx).ant-layout {
    background: white;
  }
`;

export const StyledLink = styled(Link)`
  color: #bcc8e3 !important;
  &:hover {
    color: #bcc8e3 !important;
  }
`;

export const StyledHeader = styled(Header)`
  width: 100%;
  /* position: fixed; */
  /* z-index: 10 */
  background: white;
`;

export const StyledHeaderMenu = styled(Menu)`
  display: block;
  border-bottom: 0px;

  /* & .ant-menu-item-selected a:hover {
    background-color: gray;
  } */
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected:after {
    border-bottom: 2px solid red;
  }
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover:after {
    border-bottom: 2px solid red;
  }
`;

export const StyledButton = styled(Button)`
  margin-bottom: 15px;
  /* margin-left: 50px; */
  background: whitesmoke;
  border-color: whitesmoke;
  color: black;

  &:hover {
    color: whitesmoke;
    background: black;
    border-color: black;
  }
`;

export const StyledMenu = styled(Menu)`
  border-radius: 0px;

  &:where(
      .css-dev-only-do-not-override-3mqfnx
    ).ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: orange;
  }
  &.ant-menu-inline .ant-menu-item:after {
    border-right: 3px solid orangered;
    border-radius: 0px;
  }
  &.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #ffcccb;
    color: red;
    border-radius: 0px;
  }
  &.ant-menu-light
    .ant-menu-item:not(.ant-menu-item-selected):not(
      .ant-menu-submenu-selected
    ):hover {
    color: red;
    background: #ffcccb;
  }
  & .ant-menu-item-selected {
    color: red;
    border-radius: 0px;
  }
  &:where(
      .css-dev-only-do-not-override-3mqfnx
    ).ant-menu-light.ant-menu-root.ant-menu-inline {
    border-inline-end: 0px solid rgba(5, 5, 5, 0.06);
  }
  &:where(.css-dev-only-do-not-override-3mqfnx).ant-menu-light:not(
      .ant-menu-horizontal
    )
    .ant-menu-item:not(.ant-menu-item-selected):hover,
  :where(.css-dev-only-do-not-override-3mqfnx).ant-menu-light
    > .ant-menu:not(.ant-menu-horizontal)
    .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: #ffcccb;
    border-radius: 0px;
  }
`;

export const StyledSider = styled(Sider)`
  &:where(.css-dev-only-do-not-override-3mqfnx).ant-layout
    .ant-layout-sider-trigger {
    background: orange;
  }
`;

export const StyledCategoryButton = styled(Button)`
  margin-right: 3px;
  margin-bottom: 3px;

  &:where(.css-dev-only-do-not-override-3mqfnx).ant-btn-default:not(
      :disabled
    ):not(.ant-btn-disabled):hover {
    color: orange;
    border-color: orange;
  }
`;

export const StyledPrimaryButton = styled(Button)`
  
    &&.ant-btn-primary {
    background-color: #B80000
    ;
    border-radius: 20px;
    border-color: #B80000;
    ;
    color: white;
    /* border-radius: 0px; */
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #B80000;

      color: #B80000;
      ;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledPrimaryBackButton = styled(Button)`
  
    &&.ant-btn-primary {
    background-color: white
    ;
    border-color: black;
    ;
    color: black;
    border-radius: 0px;
    font-family: "Lato";

    &:hover {
      background-color: black;
      border-color: black;

      color: white;
      ;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;